namespace GeniuzPOS.Product {
    export interface CsStyleForm {
        StyleId: Serenity.StringEditor;
        StyleName: Serenity.StringEditor;
    }

    export class CsStyleForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsStyle';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsStyleForm.init)  {
                CsStyleForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsStyleForm, [
                    'StyleId', w0,
                    'StyleName', w0
                ]);
            }
        }
    }
}
